import styled from 'styled-components';
import { body2, spacing, colors, fontWeights } from 'ui/theme';
import { ConditionInputWithoutOptions } from '../ConditionInput/ConditionInputWithoutOptions';

export const GEO_LOCATION_WIDTH = '107px';

export const FlexWrapper = styled.div`
  align-items: center;
  column-gap: ${spacing.half};
  display: flex;
`;

export const TextSecondary = styled.div`
  ${body2}
  color: ${colors.textSecondary};
`;

export const GeoLocationPrefix = styled.span`
  ${body2}
  color: ${colors.textSecondary};
  font-weight: ${fontWeights.medium};
`;

export const CustomConditionInputWithoutOptions = styled(ConditionInputWithoutOptions)`
  background: green;
`;
